<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
    <!-- <div class="footer" style="color:#939393;">
    Copyright © 2020 - 2026 沪ICP备20011159号-1
       <img  src="../static/other/ga.png" />
    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014976" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="" style="float:left;"/><p style=" color:#939393;"> 沪公网安备 31011502014976号</p></a>
  </div> -->
  </div>
 
</template>

<script>
export default {
  name: 'App',
 
}
</script>

<style>




.footer{
    height: 35px;
    line-height: 35px;
    text-align: center;
    font-size: 12px;
    border-top: 1px solid #d8dfe7;
    bottom: 0;
    left: 0;
    padding: 1px 20px;
    position: fixed;
    right: 0;
    background: #fff;
}
</style>





// WEBPACK FOOTER //
// src/App.vue